import { Component, OnInit, OnDestroy,Input,Output,EventEmitter } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { CommonService } from "../../_services/common.service";
import { HttpErrorResponse } from "@angular/common/http";
import { FlashMessagesService } from "angular2-flash-messages";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: 'app-client-address-list',
  templateUrl: './client-address-list.component.html',
  styleUrls: ['./client-address-list.component.css']
})
export class ClientAddressListComponent implements OnInit {
  public clientOptions: any = {};
  public userId:any;
  public addressId:any;
  @Input() id: any;
  @Output() toggleFormAddress = new EventEmitter<boolean>();
  public showClient=false;
  public clientLists: Array<any> = [];
  public showForm = false;
  public loading = false;
  constructor(private route: ActivatedRoute,
    private CommonService: CommonService,
    private router: Router,
    private _flashMessagesService: FlashMessagesService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.getClientAddressList();
  }
  backToList(): void {
    this.toggleFormAddress.emit();
  }
getClientAddressList = function () {
  
    this.clientOptions = {
      id:this.id
    };
    this.CommonService.apiService(
      "POST",
      "user/addresses",
      this.clientOptions
    ).subscribe(
      (response: any) => {      
        if (response.status === true) {
          if (response.data) {
            this.clientLists = response.data;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  };
  showClientAddressForm(loading)  
  { 
    if(loading==true)  
    {
      this.getClientAddressList();
    }
    this.addressId=null;
    this.userId = this.id;   
    this.showForm = !loading;
  }
  clientAddressEditForm(loading,id)
  {
    if(loading==true)  
    {
      this.getClientAddressList();
    }
    this.userId=null;
    this.addressId=id;
    this.showForm = !loading;    
  }
 
  openDialog(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to delete this address",
        manageData: { id: id }
      }
    });

    dialogRef.afterClosed().subscribe(result => {      
      if (result && result.id) {
        this.deleteAttribute(result.id);
      }
    });
  }

  deleteAttribute = function(id) {   
   
    this.CommonService.apiService(
      "DELETE",
      "user/address/"+id      
    ).subscribe(
      (response: any) => {       
        if (response.status === true) {         
          this.getClientAddressList();
          this._flashMessagesService.show("Address deleted successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });
         
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/client-address-list/client-address-list.component.ts